import styles from './Logo.module.css';

export function Logo() {
  return (
    <svg
      className={styles.logo}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M320 170l-96 96-48-48"
        stroke="var(--color-primary)"
        strokeWidth="32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80 160v128c0 102.4 72 198.4 176 224 104-25.6 176-121.6 176-224V160L256 64 80 160z"
        stroke="var(--color-primary)"
        strokeWidth="32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
